import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { buildMlpWiderrufUrl } from './mlp-widerruf.helper';

@Component({
  selector: 'app-mlp-footer',
  imports: [MatButtonModule],
  templateUrl: './mlp-footer.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MlpFooterComponent {
  readonly currentYear = new Date().getFullYear();

  protected openWiderruf(): void {
    window.open(buildMlpWiderrufUrl(), '_blank', 'noopener');
  }
}
